import { createFeatureSelector, createSelector, State } from "@ngrx/store";
import * as fromClinicianDetails from '@store/reducers/clinician-details/clinician-details.reducer'

export const selectClinicianDetailsState = createFeatureSelector<fromClinicianDetails.State>(
  fromClinicianDetails.clinicianDetailsFeatureKey
);

export const selectIsLoading = createSelector(
  selectClinicianDetailsState,
  (state) => state.isLoading
);

export const selectProviders = createSelector(
  selectClinicianDetailsState,
  (state) => state.providers || []
);

export const selectProviderTaxonomies = createSelector(
  selectClinicianDetailsState,
  (state) => state.taxonomies || []
);

export const selectError = createSelector(
  selectClinicianDetailsState,
  (state) => state.error
);
export const selectProviderUploadState = createSelector(
  selectClinicianDetailsState,
  (state) => state.providerUpload
);

export const selectProviderUploadLoading = createSelector(
  selectProviderUploadState,
  (uploadState) => uploadState.loading
);

export const selectProviderUploadProgress = createSelector(
  selectProviderUploadState,
  (uploadState) => uploadState.progress
);

export const selectProviderUploadError = createSelector(
  selectProviderUploadState,
  (uploadState) => uploadState.error
);

export const selectProviderUploadComplete = createSelector(
  selectProviderUploadState,
  (uploadState) => uploadState.complete
);

export const selectProviderUploadResults = createSelector(
  selectProviderUploadState,
  (uploadState) => uploadState.results
);